import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { Loader2, ArrowLeft, ArrowUpRight } from "lucide-react";
import { http, mediaUrl } from "../lib/api";

export default function InsightPage() {
  const { slug } = useParams();
  const [state, setState] = useState("loading");
  const [post, setPost] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);
    http.get(`/insights/${slug}`).then((r) => { setPost(r.data); setState("ready"); }).catch(() => setState("error"));
  }, [slug]);

  const fmt = (s) => { try { return new Date(s).toLocaleDateString("it-IT", { day: "2-digit", month: "long", year: "numeric" }); } catch { return s; } };

  if (state === "loading") return <div className="min-h-screen flex items-center justify-center bg-[var(--paper)]"><Loader2 className="animate-spin text-[var(--petrol)]" size={40} /></div>;
  if (state === "error") return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-[var(--paper)] text-center px-6">
      <h1 className="font-serif text-3xl text-[var(--ink)] mb-3">Contenuto non trovato</h1>
      <Link to="/#insights" className="text-[var(--accent)] link-underline">Torna agli Insights</Link>
    </div>
  );

  return (
    <div className="bg-white min-h-screen" data-testid="insight-page">
      <div className="border-b border-[var(--line)] sticky top-0 z-40 bg-white/85 backdrop-blur-xl">
        <div className="max-w-3xl mx-auto px-6 py-5">
          <Link to="/#insights" className="inline-flex items-center gap-2 text-sm text-[var(--ink-soft)] hover:text-[var(--petrol)] link-underline"><ArrowLeft size={16} strokeWidth={1.5} /> Insights</Link>
        </div>
      </div>
      <article className="max-w-3xl mx-auto px-6 py-16">
        <div className="overline mb-5">{post.category}</div>
        <h1 className="font-serif text-4xl sm:text-5xl leading-tight text-[var(--ink)]">{post.title}</h1>
        {post.subtitle && <p className="mt-5 font-serif text-xl italic text-[var(--petrol)]">{post.subtitle}</p>}
        <div className="mt-5 text-sm text-[var(--ink-soft)]">{fmt(post.date)}</div>
        {post.cover_file_id && <div className="mt-10 aspect-[16/9] overflow-hidden"><img src={mediaUrl(post.cover_file_id)} alt={post.title} className="w-full h-full object-cover" /></div>}
        <div className="mt-10 text-lg text-[var(--ink-soft)] leading-relaxed whitespace-pre-wrap">{post.body}</div>
        {post.tags?.length > 0 && (
          <div className="mt-10 flex flex-wrap gap-2">
            {post.tags.map((t, i) => <span key={i} className="text-xs uppercase tracking-[0.12em] border border-[var(--line)] px-3 py-1 text-[var(--ink-soft)]">{t}</span>)}
          </div>
        )}
        {post.external_link && <a href={post.external_link} target="_blank" rel="noreferrer" className="mt-8 inline-flex items-center gap-2 text-sm font-semibold text-[var(--accent)] link-underline">Leggi la fonte <ArrowUpRight size={15} /></a>}
      </article>
    </div>
  );
}
